import request from '@/utils/request'

/**
 * 删除模型资源
 * @param {Object} data 
 * @returns 
 */
export function deleteResource(data) {
  return request({
    url: '/model_resource/del',
    method: 'delete',
    data
  })
}

/**
 * 更新模型资源
 * @param {Object} data 
 * @returns 
 */
export function updateModelResource(data) {
  return request({
    url: '/model_resource/update',
    method: 'put',
    data
  })
}

/**
 * 新版本需求驳回
 * @param {Object} data 
 * @returns 
 */
export function updateNewModelResource(data) {
  return request({
    url: '/model_resource/updatenew',
    method: 'put',
    data
  })
}

// /**
//  * 删除模型资源
//  * @param {Object} data 
//  * @returns 
//  */
// export function deleteModel(data) {
//   return request({
//     url: '/model_resource/deleteModel',
//     method: 'put',
//     data
//   })
// }

/**
 * 添加分类
 * @param {Object} data 
 * @returns 
 */
export function addNewCategory(data) {
  return request({
    url: '/model_resource/category',
    method: 'POST',
    data
  })
}

/**
 * 保存项目的模型列表
 * @param {Object} data 
 * @returns 
 */
export function saveProjectModelResource(data) {
  return request({
    url: '/editor_model_resource/action/save',
    method: 'POST',
    data
  })
}

/**
 * 添加模型资源
 * @param {Object} data 
 * @returns 
 */
export function addModelResource(data) {
  return request({
    url: '/model_resource/add',
    method: 'POST',
    data
  })
}

/**
 * 添加资源需求的模型
 * @param {Object} data 
 * @returns 
 */
export function addModeldemandResource(data) {
  return request({
    url: '/model_resource/addDemandResource',
    method: 'POST',
    data
  })
}

/**
 * 获取相关工具
 * @param {Object} params 
 * @returns 
 */
export function getToolRelatedCategory(params) {
  return request({
    url: '/model_resource/category',
    method: 'GET',
    params
  })
}
/**
 * 获取相关工具
 * @param {Object} params 
 * @returns 
 */
export function getModelResourceList(params) {
  return request({
    url: '/model_resource/category',
    method: 'GET',
    params
  })
}


/**
 * 刷新资源列表
 * @param {Object} params 
 * @returns 
 */
export function refreshResourceList(params) {
  return request({
    // url: '/model_resource/list_model_resource?model_name={model_name}&category_type={category_type}&category_name={category_name}&page_no={page_no}&page_size={page_size}&model_resource_category={model_resource_category}&status={status}',
    url: '/model_resource/list_model_resource',
    method: 'GET',
    params
  })
}

/**
 * 刷新资源列表
 * @param {Object} params 
 * @returns 
 */
export function list_model_resourceNew(data) {
  return request({
    // url: '/model_resource/list_model_resource?model_name={model_name}&category_type={category_type}&category_name={category_name}&page_no={page_no}&page_size={page_size}&model_resource_category={model_resource_category}&status={status}',
    url: '/model_resource/list_model_resourcenew',
    method: 'POST',
    data
  })
}

/**
 *  模型开发修改模型优先级
 * @param {Object} params 
 * @returns 
 */
export function setModelPriority(data) {
  return request({
    // url: '/model_resource/list_model_resource?model_name={model_name}&category_type={category_type}&category_name={category_name}&page_no={page_no}&page_size={page_size}&model_resource_category={model_resource_category}&status={status}',
    url: '/model_resource/set_model_priority',
    method: 'POST',
    data
  })
}

/**
 * 更新模型资源状态
 * @param {Object} data 
 * @returns 
 */
export function updateModelStatus(data) {
  return request({
    url: '/model_resource/updateStatus',
    method: 'put',
    data
  })
}

/**
 *重新提交模型资源
 * @param {Object} data 
 * @returns 
 */
export function resetModelResource(data) {
  return request({
    url: '/model_resource/resetModelResource',
    method: 'put',
    data
  })
}


/**
 * 添加模型资源
 * @param {Object} data 
 * @returns 
 */
export function getByTaskIdqueryModel(data) {
  return request({
    url: '/model_resource/getByTaskIdqueryModel',
    method: 'POST',
    data
  })
}
// /**
//  * 测试
//  * @param {Object} data 
//  * @returns 
//  */
export function queryModeDev(data) {
  return request({
    url: '/model_resource/queryModeDev',
    method: 'POST',
    data
  })
}



/**
 * 获取特效资源列表
 * @param {Object} params 
 * @returns 
 */
export function getEffectsResource(data) {
  // getEffectsResource
  return request({
    // url: '/model_resource/list_model_resource?model_name={model_name}&category_type={category_type}&category_name={category_name}&page_no={page_no}&page_size={page_size}&model_resource_category={model_resource_category}&status={status}',
    url: '/model_resource/list_effects_resource',
    method: 'POST',
    data
  })
}


/**
 * 添加特效资源
 * @param {Object} data 
 * @returns 
 */
export function addEffectsModel(data) {
  return request({
    url: '/model_resource/addeffects',
    method: 'POST',
    data
  })
}

/**
 * 添加特效资源
 * @param {Object} data 
 * @returns 
 */
export function updateEffectsModel(data) {
  return request({
    url: '/model_resource/updateEffects',
    method: 'POST',
    data
  })
}

/**
 * 删除特效资源
 * @param {Object} data 
 * @returns 
 */
export function deleteEffectResource(data) {
  return request({
    url: '/model_resource/delEffect',
    method: 'delete',
    data
  })
}


//添加模型资源库收藏
export function setcollect(data) {
  return request({
    url: '/model_resource/setcollect',
    method: 'POST',
    data,
  })
}

/**
 * 查询课程模型列表
 * @param {*} params 
 * @returns 
 */
export function queryModelByCourseId(params) {
  return request({
    url: '/model_resource/queryModelByCourseId/' + params.relationId,
    method: 'GET',
    params,
  })
}

/**
 * 查询限制属性模型列表
 * @param {*} params 
 * @returns 
 */
export function queryLimitPropertyModelList(params) {
  return request({
    url: '/model_resource/queryLimitPropertyModelList',
    method: 'GET',
    params,
  })
}

/**
 * 绑定课程模型资源
 * @param {Object} data 
 * @returns 
 */
export function bindCourseModelResource(data) {
  return request({
    url: '/model_resource/bindCourseModelResource',
    method: 'POST',
    data,
  })
}

/**
 * 解除交付模型关联
 * @param {Object} data 
 * @returns 
 */
export function unbindCourseModelResource(data) {
  return request({
    url: '/model_resource/unbindCourseModelResource',
    method: 'POST',
    data,
  })
}
